<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/account">アカウント情報</router-link></li>
                <li class="breadcrumb-item">メールアドレス連携</li>
            </ol>
        </nav>
        <div class="container">
            <legend>
                メールアドレス連携
            </legend>
            <div class="forms">
                <h5>{{user.email}}</h5>
                <div class="text-secondary">
                    このメールアドレスを以下のサービスで連携ログインする。
                </div>
                <div class="form-group">
                    <a href="/login/google" class="btn btn-google btn-block">
                        <i class="fab fa-google"></i>
                        Google
                    </a>
                </div>
            </div>
            <div class="mt-5 text-center">
                <router-link to="/mypage/account">戻る</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
.forms {
    max-width: 640px;
    margin: 1rem auto;
}
.btn-twitter {
    background-color: #1DA1F2;
    color: white;
}
.btn-twitter:hover {
    background-color: #0a81ca;
    color: snow;
}
.btn-google {
    background-color: #DB4437;
    color: white;
}
.btn-google:hover {
    background-color: #b92b1e;
    color: snow;
}
</style>

<script>
export default {
    data() {
        return {
            user: {}
        }
    },
    methods: {
        load() {
            axios.get("/mypage/user/get").then(res => {
                this.user = res.data;
            }).catch(err => { alert.err(err.response) });
        }
    },
    mounted() {
        this.load();
    }
}
</script>